<template>
  <div></div>
</template>

<script type="text/babel">
export default {
  props: {
    name: {
      type: [String, Number],
      default: "",
    },
    id: {
      type: [String, Number],
      default: null,
    },
    errorName: {
      type: String,
      default: "",
    },
    value: {
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },

    placeholder: {
      type: [String, Number],
      default: "",
    },

    required: {
      default: false,
    },
    disabled: {
      default: false,
    },
    readonly: {
      default: false,
    },
    singleRow: {
      default: true,
    },
    collapsed: {
      default: false,
    },
    labelless: {
      default: false,
    },
    bottomMargin: {
      type: String,
      default: "mb-3",
    },
    labelPosition: {
      default: "right",
    },
    showExtraSlot: {
      default: false,
    },
    actualForm: {
      default: null,
    },
    autocomplete: {
      default: "chrome-off",
    },
  },

  data() {
    return {
      form: null,
      ready: false,
      errorId: null,
    };
  },

  computed: {
    actualId() {
      return this.id ? this.id : this.name;
    },
    title() {
      return this.name
        .replace(/_id$/, "")
        .replace(/_/g, " ")
        .replace(/\b\w/g, (letter) => letter.toUpperCase());
    },
    isRequired() {
      return (
        this.required !== undefined &&
        (this.required === "" || this.required === "required" || this.required === true)
      );
    },
    isDisabled() {
      return (
        this.disabled !== undefined &&
        (this.disabled === "" || this.disabled === "disabled" || this.disabled === true)
      );
    },
    isReadonly() {
      return (
        this.readonly !== undefined &&
        (this.readonly === "" || this.readonly === "disabled" || this.readonly === true)
      );
    },

    // Class calculation
    // Right now lableless and extra column for singleRow are not yet supported
    groupClass() {
      let invalid = "";
      if (this.form && this.form.errors.has(this.errorId)) {
        invalid = "invalid-wrapper";
      }

      return this.singleRow
        ? `form-component-row-single ${invalid} form-row`
        : `form-component-row ${invalid} form-row`;
    },
    lableClass() {
      if (this.labelless) {
        return "d-none";
      }

      const position = this.labelPosition === "right" ? "text-right" : "";
      const column = this.collapsed ? "col-auto" : "col-3";

      return this.singleRow
        ? `form-component-label ${column} col-form-label mb-2 ${position}`
        : "col-12 mb-2";
    },
    fieldClass() {
      if ((this.$lodash.has(this.$slots, "extra") || this.showExtraSlot) && !this.singleRow) {
        return `col ${this.bottomMargin}`;
      }

      let column = "col-12";
      if (this.singleRow) {
        if (this.collapsed) {
          column = "col";
        } else if (!this.labelless) {
          column = "col-8";
        }
      }

      return this.singleRow && !this.labelless
        ? `form-component-field ${column} ${this.bottomMargin}`
        : `form-component-field ${column} ${this.bottomMargin}`;
    },
    inputGroupClass() {
      if (this.$lodash.has(this.$slots, "prepend") || this.$lodash.has(this.$slots, "append")) {
        return "input-group";
      }

      return "";
    },
    extraSlotClass() {
      if (this.$lodash.get(this.$slots, "extra") || this.showExtraSlot) {
        return `form-component-extra extra col-auto ${this.bottomMargin}`;
      }

      return "form-component-extra d-none";
    },
  },

  created() {
    if (this.actualForm) {
      this.form = this.actualForm;
    } else {
      this.form = this.$parent.form ? this.$parent.form : this.$parent.$parent.form;
      if (!this.form) {
        this.form = this.$parent.$parent.$parent.form;
      }
    }

    this.errorId = this.errorName.length === 0 ? this.name : this.errorName;

    this.ready = true;
  },
};
</script>
